import { render, staticRenderFns } from "./PersonPicker.vue?vue&type=template&id=90fe6d58"
import script from "./PersonPicker.vue?vue&type=script&lang=js"
export * from "./PersonPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports